import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import isEmail from 'validator/lib/isEmail';
import request from 'superagent';
import {
  checkEmail,
  sendConfirm,
  fetchAuth,
  logout,
} from '../actions/auth';
import { Translate, I18n } from 'react-redux-i18n';
import AuthLangSwitch from './AuthLangSwitch';

import '../styles/auth-page.scss';

class EmailInput extends React.PureComponent {
  constructor(...props) {
    super(...props);

    this.confirmEmail = this.confirmEmail.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.state = {
      email: this.props.user ? this.props.user.email : '',
      emailValid: true,
    };
  }

  handleEmailChange(event) {
    const email = event.target.value;
    const emailValid = isEmail(email);
    this.setState({ email, emailValid });
    if (this.props.check) {
      this.props.check(email);
    }
  }

  confirmEmail(e) {
    e.preventDefault();
    const { send, logout: doLogout, user } = this.props;
    const { email } = this.state;

    send(email);

    if (user && user.email === email) {
      browserHistory.push('/i');
    } else if (user) {
      doLogout();
    }

    return false;
  }

  render() {
    const { email, emailValid } = this.state;
    const { user, emailFree } = this.props;

    const allValid =
      emailValid && (!user || emailFree || email === user.email);

    let emailClass = '';
    let emailMessage = '';
    if (email) {
      if (!emailValid) {
        emailClass = 'has-error';
        emailMessage = <Translate value="register.errors.email.wrong" />;
      } else if (user && !(emailFree || email === user.email)) {
        emailClass = 'has-error';
        emailMessage = <Translate value="register.errors.email.taken" />;
      }
    }

    return (
      <form className="rts-auth__card rts-auth__card--reset" onSubmit={this.confirmEmail}>
        <h1 className="rts-auth__title">
          <Translate value="auth.confirm.isCorrect" />
        </h1>

        <div className={`rts-auth__field ${emailClass}`}>
          <input
            type="email"
            className="rts-auth__input rts-auth__input--outlined"
            placeholder={I18n.t('auth.placeholders.email')}
            autoComplete="email"
            value={email}
            onChange={this.handleEmailChange}
          />
          {emailMessage && (
            <span className="rts-auth__error">{emailMessage}</span>
          )}
        </div>

        <button
          type="submit"
          className="rts-auth__submit"
          disabled={!allValid}
        >
          <Translate value="auth.confirm.sendMail" />
        </button>
      </form>
    );
  }
}

class ConfirmEmail extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    const token = props.params.token || null;

    this.state = {
      token,
      tokenConfirmStatus: token ? 'loading' : null,
    };
  }

  componentDidMount() {
    const { user } = this.props;
    const { token } = this.state;

    if (!token && !user) {
      browserHistory.replace('/i/auth');
      return;
    }

    if (token) {
      request.post(`/user/confirm/${token}`).end((err) => {
        this.setState({
          tokenConfirmStatus: err ? 'error' : 'success',
        });
        if (!err) {
          this.props.fetchAuth();
        }
      });
    }
  }

  renderLogo() {
    return (
      <img
        className="rts-auth__logo-outside"
        src="/rts-logo.64cace62.png"
        alt="Rocket Tech School"
      />
    );
  }

  renderBackToLogin() {
    return (
      <div className="rts-auth__register">
        <Link to="/i/auth" className="rts-auth__register-btn">
          <Translate value="auth.reset.backToLogin" />
        </Link>
      </div>
    );
  }

  renderCheckMail() {
    return (
      <div className="rts-auth__card rts-auth__card--reset">
        <h1 className="rts-auth__title">
          <Translate value="auth.confirm.pleaseConfirm" />
        </h1>
        <p className="rts-auth__description rts-auth__description--success">
          <Translate value="auth.confirm.checkMail" />
        </p>
        {this.renderBackToLogin()}
      </div>
    );
  }

  renderTokenLoading() {
    return (
      <div className="rts-auth__card rts-auth__card--reset">
        <h1 className="rts-auth__title">
          <Translate value="auth.confirm.pleaseConfirm" />
        </h1>
        <p className="rts-auth__description">
          <span className="fa fa-spinner fa-spin" aria-hidden="true" />
          &nbsp;
          Loading...
        </p>
      </div>
    );
  }

  renderTokenSuccess() {
    return (
      <div className="rts-auth__card rts-auth__card--reset">
        <h1 className="rts-auth__title">
          <Translate value="auth.confirm.success" />
        </h1>
        <Link to="/i/all" className="rts-auth__submit" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}>
          <Translate value="auth.confirm.button" />
        </Link>
      </div>
    );
  }

  renderTokenError() {
    const { user, emailFree, check, send, logout: doLogout } = this.props;

    return (
      <div>
        <div className="rts-auth__card rts-auth__card--reset">
          <h1 className="rts-auth__title">
            <Translate value="auth.confirm.pleaseConfirm" />
          </h1>
          <p
            className="rts-auth__description"
            dangerouslySetInnerHTML={{ __html: I18n.t('auth.confirm.error') }}
          />
        </div>
        {user ? (
          <EmailInput
            user={user}
            emailFree={emailFree}
            logout={doLogout}
            check={check}
            send={send}
          />
        ) : (
          this.renderBackToLogin()
        )}
      </div>
    );
  }

  renderRequestConfirm() {
    const { result, user, emailFree, check, send, logout: doLogout } = this.props;

    if (result) {
      return this.renderCheckMail();
    }

    return (
      <EmailInput
        user={user}
        emailFree={emailFree}
        logout={doLogout}
        check={check}
        send={send}
      />
    );
  }

  render() {
    const { token, tokenConfirmStatus } = this.state;
    const { user } = this.props;

    let content;
    if (token) {
      if (tokenConfirmStatus === 'loading') {
        content = this.renderTokenLoading();
      } else if (
        tokenConfirmStatus === 'success' ||
        (user && user.confirmed)
      ) {
        content = this.renderTokenSuccess();
      } else {
        content = this.renderTokenError();
      }
    } else {
      content = this.renderRequestConfirm();
    }

    return (
      <div className="rts-auth rts-auth--reset">
        {this.renderLogo()}
        {content}
        <AuthLangSwitch />
      </div>
    );
  }
}

ConfirmEmail.propTypes = {
  result: PropTypes.bool,
  params: PropTypes.object.isRequired,
  user: PropTypes.object,
  emailFree: PropTypes.bool,
  fetchAuth: PropTypes.func.isRequired,
  send: PropTypes.func.isRequired,
  check: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

ConfirmEmail.defaultProps = {
  result: false,
  user: false,
  emailFree: true,
};

const mapStateToProps = state => ({
  user: state.auth.user,
  emailFree: state.register.emailFree,
  result: state.auth.reset ? state.auth.reset.result : false,
});

const mapDispatchToProps = dispatch => ({
  send: email => dispatch(sendConfirm(email)),
  check: email => dispatch(checkEmail(email)),
  logout: () => dispatch(logout()),
  fetchAuth: () => dispatch(fetchAuth()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);
